import {$qs, $qsAll} from '../../@shared/ts/dom';

declare const peachpay_admin: PeachPayAdminData;

function gatewayCurrencyAndCountryFilters() {
	const $countryAvailability = $qs<HTMLSelectElement>('.pp-custom-country-availability');
	const $countryDescription = $qs('.pp-custom-countries')?.nextElementSibling;
	const $currencyAvailability = $qs<HTMLSelectElement>('.pp-custom-currency-availability');
	const $currencyDescription = $qs('.pp-custom-currencies')?.nextElementSibling;

	if ($countryAvailability && $countryDescription && $countryDescription.classList.contains('description')) {
		$countryAvailability.addEventListener('change', () => {
			if ($countryAvailability.value === 'block') {
				$countryDescription.innerHTML = peachpay_admin.translations.country_description_block;
			} else {
				$countryDescription.innerHTML = peachpay_admin.translations.country_description_allow;
			}
		});
	}

	if ($currencyAvailability && $currencyDescription && $currencyDescription.classList.contains('description')) {
		$currencyAvailability.addEventListener('change', () => {
			if ($currencyAvailability.value === 'block') {
				$currencyDescription.innerHTML = peachpay_admin.translations.currency_description_block;
			} else {
				$currencyDescription.innerHTML = peachpay_admin.translations.currency_description_allow;
			}
		});
	}
}

function hideCustomCountriesAndCurrenciesOptions() {
	const $countryAvailability = $qs<HTMLSelectElement>('.pp-custom-country-availability');
	const $countrySelectTr = $qs<HTMLSelectElement>('.pp-custom-countries')?.closest('tr');
	const $currencyAvailability = $qs<HTMLSelectElement>('.pp-custom-currency-availability');
	const $currencySelectTr = $qs<HTMLSelectElement>('.pp-custom-currencies')?.closest('tr');

	if ($countryAvailability && $countrySelectTr) {
		$countryAvailability.addEventListener('change', () => {
			if ($countryAvailability.value === 'all') {
				$countrySelectTr.style.display = 'none';
			} else {
				$countrySelectTr.style.display = 'table-row';
			}
		});
		if ($countryAvailability.value === 'all') {
			$countrySelectTr.style.display = 'none';
		}
	}

	if ($currencyAvailability && $currencySelectTr) {
		const updateDefaultCurrencyAvailability = () => {
			const $allCurrencies = $qsAll<HTMLOptionElement>('.pp-custom-currencies option');
			if ($currencyAvailability.value === 'all') {
				$currencySelectTr.style.display = 'none';

				setDefaultCurrencySelectorOptions($allCurrencies);
			} else {
				$currencySelectTr.style.display = 'table-row';

				if ($currencyAvailability.value === 'block') {
					const $selectedCurrencies = $allCurrencies.filter($currency => !$currency.selected);
					setDefaultCurrencySelectorOptions($selectedCurrencies);
				} else {
					const $selectedCurrencies = $allCurrencies.filter($currency => $currency.selected);
					setDefaultCurrencySelectorOptions($selectedCurrencies);
				}
			}
		};

		$currencyAvailability.addEventListener('change', updateDefaultCurrencyAvailability);

		if ($currencyAvailability.value === 'all') {
			$currencySelectTr.style.display = 'none';
		}

		// Building setTimeout selection because the span with the current selected currencies doesn't exist
		//  until after this logic runs.
		setTimeout(() => {
			const $allCurrencies = $qsAll<HTMLOptionElement>('.pp-custom-currencies option');

			// Attach currency selector listener.
			$qs('.pp-custom-currencies ~ span')?.addEventListener('focusout', updateDefaultCurrencyAvailability);

			// Attach button listeners.
			$qsAll('a.button.select_none, a.button.select_all', $selectButton => {
				$selectButton.addEventListener('click', function () {
					if (this.classList.contains('select_all')) {
						setDefaultCurrencySelectorOptions($allCurrencies);
					} else {
						setDefaultCurrencySelectorOptions([]);
					}
				});
			});

			if ($currencyAvailability.value === 'all') {
				setDefaultCurrencySelectorOptions($allCurrencies);
			} else if ($currencyAvailability.value === 'block') {
				const $selectedCurrencies = $allCurrencies.filter($currency => !$currency.selected);
				setDefaultCurrencySelectorOptions($selectedCurrencies);
			} else {
				const $selectedCurrencies = $allCurrencies.filter($currency => $currency.selected);
				setDefaultCurrencySelectorOptions($selectedCurrencies);
			}
		});
	}

	// Hide default currency selector IFF it has the class 'pp-default-currency-hide'.
	const $defaultCurrencyTr = $qs<HTMLSelectElement>('.pp-default-currency-hide')?.closest('tr');
	if ($defaultCurrencyTr) {
		$defaultCurrencyTr.style.display = 'none';
	}
}

function setDefaultCurrencySelectorOptions($activeCurrencies: NodeListOf<Element> | Element[] | undefined) {
	if (!$activeCurrencies) {
		return;
	}

	const $defaultCurrencySelector = $qs<HTMLSelectElement>('select[name$="_default_currency"]');
	let currentDefaultCurrency = 'none';
	if ($defaultCurrencySelector) {
		const prevDefaultCurrency = $defaultCurrencySelector.value;
		$defaultCurrencySelector.innerHTML = '<option value="none">Not set</option>';

		$activeCurrencies?.forEach(activeCurrency => {
			const currencyTitle = activeCurrency.innerHTML;

			if (currencyTitle) {
				$defaultCurrencySelector.innerHTML += `<option value="${currencyTitle}">${currencyTitle}</option>`;

				if (prevDefaultCurrency === currencyTitle) {
					currentDefaultCurrency = currencyTitle;
				}
			}
		});

		$defaultCurrencySelector.value = currentDefaultCurrency;
	}
}

function insertControlButtons() {
	const $supportedCountry = $qs('.pp-custom-countries');
	const $supportedCurrency = $qs('.pp-custom-currencies');

	const lineBreak = document.createElement('br');

	const selectAll = document.createElement('a');
	selectAll.classList.add('select_all', 'button');
	selectAll.href = '#';
	selectAll.innerText = peachpay_admin.translations.select_all;

	const selectNone = document.createElement('a');
	selectNone.classList.add('select_none', 'button');
	selectNone.href = '#';
	selectNone.innerText = peachpay_admin.translations.select_none;
	selectNone.style.marginLeft = '5px';

	$supportedCurrency?.insertAdjacentElement('afterend', selectNone);
	$supportedCurrency?.insertAdjacentElement('afterend', selectAll);
	$supportedCountry?.insertAdjacentElement('afterend', (selectNone.cloneNode(true) as Element));
	$supportedCountry?.insertAdjacentElement('afterend', (selectAll.cloneNode(true) as Element));

	$supportedCurrency?.insertAdjacentElement('afterend', lineBreak);
	$supportedCountry?.insertAdjacentElement('afterend', (lineBreak.cloneNode(true) as Element));
}

/** Detect if supported currency/country list exceeds 3 lines then display the "see more" buttons. */
function displaySeeMoreButtons() {
	if (!($qs('#peachpay_settings_container') ?? $qs('#peachpay-gateway-settings'))) {
		return;
	}

	const render = () => {
		document.querySelectorAll('.pp-admin-content .see-more-target').forEach(($element: HTMLElement) => {
			const $seeMoreWrap = $element.closest('.see-more-wrap');
			const $seeMoreTarget = $seeMoreWrap?.querySelector<HTMLElement>('.see-more-target');

			if (!$seeMoreWrap || !$seeMoreTarget) {
				return;
			}

			// Target height
			const offsetHeight = $seeMoreTarget.scrollHeight;
			const maxHeight = Number($seeMoreTarget.style.maxHeight.replace(/\D/g, ''));

			if (offsetHeight && maxHeight && offsetHeight > maxHeight) { // Display see more button
				$seeMoreWrap?.parentElement?.querySelector('.see-more-trigger')?.classList.remove('hide');
			} else { // Hide see more button
				$seeMoreWrap?.parentElement?.querySelector('.see-more-trigger')?.classList.add('hide');
			}
		});
	};

	render();

	// Attach listener to sub nav to make sure see more buttons in different sub-navs are populated
	$qsAll('#peachpay_settings_container .pp-sub-nav-button:not(.pp-sub-nav-floating)', $subNavButton => {
		$subNavButton.addEventListener('click', () => {
			render();
		});
	});

	window.addEventListener('resize', () => {
		render();
	});
}

export {gatewayCurrencyAndCountryFilters, hideCustomCountriesAndCurrenciesOptions, insertControlButtons, displaySeeMoreButtons};
